import { useParams } from "react-router";
import { portfolioAll } from "../../content/portfolio";
import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../languages/languageContext";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaExternalLinkAlt, FaGithub } from "react-icons/fa";

interface StackItemProps {
  stack: StackProps;
}

const StackItem: React.FC<StackItemProps> = ({ stack }) => (
  <div className={`flex flex-col items-center text-gray-700 [&>svg]:text-4xl `}>
    <stack.Icon />
    <span className="text-base">{stack.name}</span>
  </div>
);

const ProjectPage = () => {
  const language_id = useContext(LanguageContext).id;
  const language = useContext(LanguageContext).projects;

  const { slug } = useParams();

  const project = portfolioAll.projects?.filter(
    (project) =>
      project.slug["english"] === slug || project.slug["portuguese"] === slug
  )[0];

  useEffect(() => {
    window.history.pushState(
      {},
      "",
      project?.slug[language_id as keyof IProject["slug"]]
    );
  }, [language_id]);

  return (
    <article className="[&_h2]:text-2xl sm:[&_h2]:text-xl [&_section]:mb-10">
      <Link
        to="/projects"
        className="mb-8 flex items-center text-xl text-[blue] hover:underline"
      >
        <FaChevronLeft />
        {language.allProjects}
      </Link>
      <div className="sm:px-10">
        <div className="mb-12 flex flex-wrap items-center justify-center gap-2 py-1 [&>a]:flex [&>a]:w-fit [&>a]:items-center [&>a]:gap-1 [&>a]:rounded [&>a]:px-2 [&>a]:text-base [&>a]:font-bold [&>a]:text-white">
          <a
            target="_blank"
            href={project?.projectLink}
            className=" bg-blue-700"
          >
            <FaExternalLinkAlt />

            <span>{language.viewLiveProject}</span>
          </a>

          {project?.githubLink && (
            <a
              target="_blank"
              href={project?.githubLink}
              className="bg-gray-900"
            >
              <FaGithub />
              <span>{language.viewGithubCode}</span>
            </a>
          )}
        </div>

        <section>
          <h1 className="mb-8 text-center text-3xl sm:text-4xl">
            {project?.title[language_id as keyof IProject["title"]]}
          </h1>
          <a href={project?.projectLink} target="_blank">
            <img
              className="rounded-xl border-2"
              src={project?.coverImage}
              alt=""
            />
          </a>
        </section>

        <section>
          <h2 className="mb-6">{language.technologies}</h2>
          <div className="flex flex-wrap items-center justify-center gap-4 text-gray-600 sm:gap-8 sm:p-10">
            {project?.stack.map((s, idx) => (
              <StackItem key={idx} stack={s} />
            ))}
          </div>
        </section>

        <section>
          <h2 className="mb-6">{language.description}</h2>
          <p className="whitespace-pre-line text-lg text-gray-600 sm:text-xl	">
            {project?.description[language_id as keyof IProject["description"]]}
          </p>
        </section>

        {project?.features[language_id as keyof IProject["features"]].length ? (
          <section>
            <h2 className="mb-6">{language.features}</h2>
            <ul className="list-disc pl-5 text-gray-600">
              {project?.features[language_id as keyof IProject["features"]].map(
                (feature, idx) => (
                  <li className="text-lg sm:text-xl" key={idx}>
                    {feature}
                  </li>
                )
              )}
            </ul>
          </section>
        ) : (
          <></>
        )}

        <section>
          <h2 className="mb-6">Images</h2>
          <div className="grid grid-cols-2 gap-2">
            {project?.images.map((image, idx) => (
              <img src={image} key={idx} alt="" className="rounded border-2" />
            ))}
          </div>
        </section>
      </div>
    </article>
  );
};

export default ProjectPage;
